export function randomIndex(arrayToPullFrom: any[]) {
  return Math.floor(Math.random() * arrayToPullFrom.length);
}

export function randomElement(arrayToPullFrom: any[]) {
  return arrayToPullFrom[randomIndex(arrayToPullFrom)];
}
